import React from "react"
import styled from "styled-components"
import { SwiperSlide } from "swiper/react"
import { FluidObject } from "gatsby-image"
import {
  ApartmentBlock as ApartmentBlockBase,
  SectionTitle,
  SectionSubTitle,
  ImageSliderWrapper,
} from "../elements"

const ApartmentsContainer = styled.div`
  background-color: var(--bg-secondary);
  padding: 50px 0;

  @media (${({ theme }): string => theme.screenSizes.sm}) {
    padding: 100px 0;
  }
`

const ApartmentBlock = styled(ApartmentBlockBase)`
  width: 100vw;

  @media (${({ theme }): string => theme.screenSizes.sm}) {
    width: 55vw;
  }

  @media (${({ theme }): string => theme.screenSizes.lg}) {
    width: 35vw;
  }
`

type ApartmentSummary = {
  type: string
  price: number
  description: string
  link: string
  image: FluidObject
}

type Props = {
  title?: string
  apartments: Array<ApartmentSummary>
}

const ApartmentsSlider: React.FC<Props> = ({
  title = "Explore the apartments for sale",
  apartments,
  ...props
}: Props) => {
  return (
    <ApartmentsContainer {...props}>
      <SectionTitle>{title}</SectionTitle>
      <SectionSubTitle>
        <strong>12 floors / 200 apartments</strong>
      </SectionSubTitle>

      <ImageSliderWrapper>
        {apartments.map((apartment, index) => (
          <SwiperSlide key={`apartment-${index}`}>
            <ApartmentBlock
              name={apartment.type}
              price={apartment.price}
              description={apartment.description}
              link={apartment.link}
              image={apartment.image}
              type={apartment.type}
            />
          </SwiperSlide>
        ))}
      </ImageSliderWrapper>
    </ApartmentsContainer>
  )
}

export default ApartmentsSlider
